import React,{ useState,useEffect } from 'react';
import Input from '../Common/Input';
import ReactSelect from '../Common/ReactSelect';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Form = ({ formik }) => {

    const [branchs,setBranchs] = useState([]);
    const {readData: getBranchs} = useEntityCrud('Branch/GetAllBranchs');
    const [roles,setRoles] = useState([]);
    const {readData: getRoles} = useEntityCrud('Role/GetAllRole');
    const [persons,setPersons] = useState([]);
    const {readData: getPersons} = useEntityCrud('Person/GetAllPersons');
    const [businesses,setBusinesses] = useState([]);
    const {readData: getBusiness} = useEntityCrud('Business/GetAllBusiness');
    const [groups,setGroups] = useState([]);
    const {readData: getGroups} = useEntityCrud('Group/GetAllGroups?buisnessId=' + formik.values.businessId);
    const [services,setServices] = useState([]);
    const {readData: getServices} = useEntityCrud('Service/GetAllServices?groupId=' + formik.values.groupId);
    const [subServices,setSubServices] = useState([]);
    const {readData: getSubServices} = useEntityCrud('SubService/GetAllSubServices?serviceId=' + formik.values.serviceId);

    useEffect(() => {
        getRoles().then(({data}) => {
            let roles = [];
            if(data.status)
                data.result.map(item => {
                    roles.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setRoles(roles);
        })
        getBranchs().then(({data}) => {
            let branchs = [];
            if(data.status)
                data.result.map(item => {
                    if(item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })
        getBusiness().then(({data}) => {
            let businesses = [];
            if(data.status)
                data.result.map(item => {
                    if(item.isActive)
                        businesses.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBusinesses(businesses);
        })
    },[])

    useEffect(() => {
        const postedData = {
            name: '',
            lastName: '',
            email: '',
            phone: '',
            cellphone: '',
            branchTitle: '',
            nationalCode: '',
            roleId: formik.values.roleId,
            branchId: formik.values.branchId
        };
        getPersons(postedData).then(({data}) => {
            let persons = [];
            if(data.status)
                data.result.map(item => {
                    persons.push({
                        label: item.name + ' ' + item.lastName,
                        value: item.id
                    });
                })
            setPersons(persons);
        })
    },[formik.values.roleId])
    
    useEffect(() => {
        formik.setFieldValue('groupId',0);
        formik.setFieldValue('serviceId',0);
        formik.setFieldValue('subServiceId',0);
        if(formik.values.businessId)
            getGroups().then(({data}) => {
                let groups = [];
                if(data.status)
                    data.result.map(item => {
                        if(item.isActive)
                            groups.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                setGroups(groups);
            });
    },[formik.values.businessId])

    useEffect(() => {
        formik.setFieldValue('serviceId',0);
        formik.setFieldValue('subServiceId',0);
        if(formik.values.groupId)
            getServices().then(({data}) => {
                let services = [];
                if(data.status)
                    data.result.map(item => {
                        if(item.isActive)
                            services.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                setServices(services);
            });
    },[formik.values.groupId])

    useEffect(() => {
        formik.setFieldValue('subServiceId',0);
        if(formik.values.serviceId)
            getSubServices().then(({data}) => {
                let subServices = [];
                if(data.status)
                    data.result.map(item => {
                        if(item.isActive)
                            subServices.push({
                                label: item.title,
                                value: item.id
                            });
                    })
                setSubServices(subServices);
            });
    },[formik.values.serviceId])

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <ReactSelect label="کسب و کار" formik={formik} options={businesses} required={true} name="businessId" value={businesses.filter(item => item.value == formik.values.businessId)} />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="گروه" formik={formik} options={groups} required={true} name="groupId" value={groups.filter(item => item.value == formik.values.groupId)} />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="سرویس" formik={formik} options={services} required={true} name="serviceId" value={services.filter(item => item.value == formik.values.serviceId)} />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="محصول / خدمت" formik={formik} options={subServices} required={true} name="subServiceId" value={subServices.filter(item => item.value == formik.values.subServiceId)} />
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-2">
                    <Input label="درصد تخفیف" name="discountPercentage" required={true} formik={formik} isLtr={true} type="number" max="100" />
                </div>
                <div className="col-md-2">
                    <Input label="حداکثر میزان تخفیف" name="maxDiscount" required={true} formik={formik} isLtr={true} type="tel" />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="شرکت زیر مجموعه" options={branchs} name="branchId" formik={formik} required={true} value={branchs.filter(item => item.value == formik.values.branchId)} />
                </div>
                <div className="col-md-2">
                    <ReactSelect label="نقش" options={roles} name="roleId" formik={formik} required={true} value={roles.filter(item => item.value == formik.values.roleId)} />
                </div>
                <div className="col-md-12">
                    <ReactSelect label="پرسنل (در صورتی که فقط بعضی از پرسنل شامل این تخفیف می شوند این قسمت را تکمیل کنید)" options={persons} name="personId" isMulti={true} formik={formik} required={false} />
                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;